(function(){
  "use strict";

  /**
    * Global helper to show and enable a section of a form when a flag is true,
    * and hide it when false
    *
    * @param show_section {boolean} - true means section is shown, false means it's hidden
    * @param section_selector {string} jQuery selector for the section to show/hide
  */
  window.showOrHideFormSectionWithBoolean = function(show_section, section_selector) {
    var disabled = !show_section;
    var $section = $(section_selector);

    if ($section.hasClass('hidden') !== disabled){
      if (disabled){
        bootstrap.hide($section);
      } else {
        bootstrap.show($section);
      }
    }

    $section.find('input').prop('disabled', disabled);
    $section.find('textarea').prop('disabled', disabled);
    $section.find('select').prop('disabled', disabled).trigger('chosen:updated');
  }
})();